var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 3.60156H11.0663V11.0682H3.59961V3.60156ZM5.46628 5.46823V9.20156H9.19961V5.46823H5.46628ZM12.9329 3.60156H20.3996V11.0682H12.9329V3.60156ZM14.7996 5.46823V9.20156H18.5329V5.46823H14.7996ZM3.59961 12.9349H11.0663V20.4016H3.59961V12.9349ZM5.46628 14.8016V18.5349H9.19961V14.8016H5.46628Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7329 12.9349V15.7349H12.9329V17.6016H15.7329V20.4016H17.5996V17.6016H20.3996V15.7349H17.5996V12.9349H15.7329Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNew);
export default __webpack_public_path__ + "static/media/icon-new.51af255db940a64699fa8dd4e92b16bf.svg";
export { ForwardRef as ReactComponent };